exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Ij1xLT_HLp88M37zkVcqx{font-weight:600}html[dir] ._23f4dMU1_LGLt4GgPo3Lk9 .ms-ContextualMenu-header{padding:0 4px}._2XmjPcdNPHzJnErHgc7pg8{font-weight:700}", ""]);
// Exports
exports.locals = {
	"checkedItem": "_2Ij1xLT_HLp88M37zkVcqx",
	"sectionHeader": "_23f4dMU1_LGLt4GgPo3Lk9",
	"checkmark": "_2XmjPcdNPHzJnErHgc7pg8"
};